import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import { ELEMENT_COLORS, ELEMENT_ICONS, DEFAULT_ELEMENT_COLOR, DEFAULT_ELEMENT_ICON, elementLabel as arenaElementLabel, BONUS_EFFECT_COLORS, BONUS_EFFECT_ICONS, BONUS_COLOR, formatBonusDescription, ARENA_ICONS } from '../../common';
import attachCardTilt from '../../common/helpers/attachCardTilt';
export default class CardComponent extends Component {
  // 3D pointer-tilt, full cards only (mini slider thumbnails are too small for it
  // to read). See common/helpers/attachCardTilt.ts for the implementation.

  detachTiltFn = null;
  attachTilt = vnode => {
    this.detachTiltFn = attachCardTilt(vnode.dom);
  };
  detachTilt = () => {
    this.detachTiltFn?.();
    this.detachTiltFn = null;
  };
  view() {
    const {
      card,
      selected,
      disabled,
      compact,
      cardBackImage,
      onclick
    } = this.attrs;
    return card.isBonus() ? this.viewBonus(card, selected, disabled, compact, cardBackImage, onclick) : this.viewElemental(card, selected, disabled, compact, cardBackImage, onclick);
  }
  viewElemental(card, selected, disabled, compact, cardBackImage, onclick) {
    const element = card.element();
    const color = ELEMENT_COLORS[element] || DEFAULT_ELEMENT_COLOR;
    const icon = ELEMENT_ICONS[element] || DEFAULT_ELEMENT_ICON;
    const label = arenaElementLabel(element);
    return m("div", Object.assign({
      className: ['ArenaCard', 'ArenaCard--elemental', selected ? 'ArenaCard--selected' : '', disabled ? 'ArenaCard--disabled' : '', compact ? 'ArenaCard--compact' : 'ArenaCard--full'].filter(Boolean).join(' '),
      onclick: !disabled && onclick ? () => onclick(card) : undefined,
      style: {
        '--element-color': color
      }
    }, !compact ? {
      oncreate: this.attachTilt,
      onremove: this.detachTilt
    } : {}), m("div", {
      className: `ArenaCard-header${cardBackImage ? ' ArenaCard-header--skinned' : ''}`,
      style: cardBackImage ? {
        backgroundImage: `url(${cardBackImage})`
      } : {
        backgroundColor: color
      }
    }, m("div", {
      className: "ArenaCard-avatar"
    }, card.imageUrl() ? m("img", {
      src: card.imageUrl(),
      alt: card.name()
    }) : m("i", {
      className: icon
    }))), m("div", {
      className: "ArenaCard-body"
    }, m("div", {
      className: "ArenaCard-name"
    }, card.name()), !compact && card.description() && m("div", {
      className: "ArenaCard-description"
    }, card.description()), m("div", {
      className: "ArenaCard-footer"
    }, !compact && m("div", {
      className: "ArenaCard-bonusTag"
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), " ", label), m("div", {
      className: `ArenaCard-stats ${compact ? 'ArenaCard-stats--compact' : ''}`
    }, m("span", {
      className: "ArenaCard-stat ArenaCard-stat--attack",
      title: app.translator.trans('forumaker-arena.admin.card_edit.attack_label')
    }, m("i", {
      className: ARENA_ICONS.attack
    }), " ", m("span", null, card.attack())), m("span", {
      className: "ArenaCard-stat ArenaCard-stat--defense",
      title: app.translator.trans('forumaker-arena.admin.card_edit.defense_label')
    }, m("i", {
      className: ARENA_ICONS.defense
    }), " ", m("span", null, card.defense())), m("span", {
      className: "ArenaCard-stat ArenaCard-stat--cost",
      title: app.translator.trans('forumaker-arena.lib.stats.mana')
    }, m("i", {
      className: ARENA_ICONS.mana
    }), " ", m("span", null, card.cost()))))));
  }
  viewBonus(card, selected, disabled, compact, cardBackImage, onclick) {
    const effect = card.bonusEffect() ?? '';
    const color = BONUS_EFFECT_COLORS[effect] || BONUS_COLOR;
    const icon = BONUS_EFFECT_ICONS[effect] || 'fas fa-star';
    const label = effect ? app.translator.trans(`forumaker-arena.lib.bonus_effects.${effect}`) : app.translator.trans('forumaker-arena.admin.card_edit.type_bonus');
    // formatBonusDescription (plain string), NOT app.translator.trans():
    // trans() with a numeric ICU param returns an ARRAY of Mithril children,
    // and .ArenaCard-description is a -webkit-box with -webkit-line-clamp —
    // WebKit's clamp misplaces its ellipsis when the box has several inline
    // children, drawing "…" mid-element even though the text fits the three
    // lines. Same pitfall CardEditModal's preview already documents.
    const desc = card.description() || (effect ? formatBonusDescription(effect, card.bonusValue() ?? null) : '');
    const cardEl = m("div", Object.assign({
      className: ['ArenaCard', 'ArenaCard--bonus', selected ? 'ArenaCard--selected' : '', disabled ? 'ArenaCard--disabled' : '', compact ? 'ArenaCard--compact' : 'ArenaCard--full'].filter(Boolean).join(' '),
      onclick: !disabled && onclick ? () => onclick(card) : undefined,
      style: {
        '--element-color': color
      }
    }, !compact ? {
      oncreate: this.attachTilt,
      onremove: this.detachTilt
    } : {}), m("div", {
      className: `ArenaCard-header ArenaCard-header--bonus${cardBackImage ? ' ArenaCard-header--skinned' : ''}`,
      style: cardBackImage ? {
        backgroundImage: `url(${cardBackImage})`
      } : {
        backgroundColor: color
      }
    }, m("div", {
      className: "ArenaCard-avatar"
    }, card.imageUrl() ? m("img", {
      src: card.imageUrl(),
      alt: card.name()
    }) : m("i", {
      className: icon
    }))), m("div", {
      className: "ArenaCard-body ArenaCard-body--bonus"
    }, m("div", {
      className: "ArenaCard-name"
    }, card.name()), !compact && desc && m("div", {
      className: "ArenaCard-description ArenaCard-description--bonus"
    }, desc), m("div", {
      className: "ArenaCard-footer"
    }, !compact && m("div", {
      className: "ArenaCard-bonusTag"
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), " ", label), m("div", {
      className: `ArenaCard-stats ${compact ? 'ArenaCard-stats--compact' : ''}`
    }, m("span", {
      className: "ArenaCard-stat ArenaCard-stat--cost",
      title: app.translator.trans('forumaker-arena.lib.stats.mana')
    }, m("i", {
      className: ARENA_ICONS.mana
    }), " ", m("span", null, card.cost()))))));

    // Compact cards (slider thumbnails) hide the description text to stay
    // small, so surface it as a hover tooltip instead.
    return compact && desc ? m(Tooltip, {
      text: desc
    }, cardEl) : cardEl;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CardComponent', CardComponent);